import { onMounted, watch } from 'vue';

/**
 * Composable for managing dynamic meta tags
 * @param {Object} metaConfig - Configuration object for meta tags
 */
export function useMeta(metaConfig) {
  const updateMeta = () => {
    // Update document title
    if (metaConfig.title) {
      document.title = metaConfig.title;
    }

    // Update meta description
    updateOrCreateMeta('name', 'description', metaConfig.description);

    // Update OG tags
    updateOrCreateMeta('property', 'og:title', metaConfig.ogTitle || metaConfig.title);
    updateOrCreateMeta('property', 'og:description', metaConfig.ogDescription || metaConfig.description);
    updateOrCreateMeta('property', 'og:image', metaConfig.ogImage);
    updateOrCreateMeta('property', 'og:url', metaConfig.canonical);
    updateOrCreateMeta('property', 'og:type', 'website');

    // Update Twitter Card
    updateOrCreateMeta('name', 'twitter:card', 'summary_large_image');
    updateOrCreateMeta('name', 'twitter:title', metaConfig.ogTitle || metaConfig.title);
    updateOrCreateMeta('name', 'twitter:description', metaConfig.ogDescription || metaConfig.description);
    updateOrCreateMeta('name', 'twitter:image', metaConfig.ogImage);

    // Update canonical
    updateOrCreateLink('rel', 'canonical', metaConfig.canonical);
  };

  onMounted(updateMeta);

  // Watch for changes if metaConfig is reactive
  if (metaConfig.title && typeof metaConfig.title === 'object') {
    watch(metaConfig, updateMeta, { deep: true });
  }
}

function updateOrCreateMeta(attribute, key, content) {
  if (!content) return;

  let element = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function updateOrCreateLink(attribute, key, href) {
  if (!href) return;

  let element = document.querySelector(`link[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
}

export default useMeta;
